// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uVFb","content":"styles_content__3VDz4"};